// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__3T5vZ","loader":"Spinner_loader__2xA_P","spin":"Spinner_spin__2dksv"};